export default {
    uniqRequestRegion: null,
    list: [],
    total: 0,
    StraValidate: false,
    MaxStraNum : 10,
};
